module.exports = __webpack_public_path__ + "img/logo.b87edbc4.png";